import styled from 'styled-components';
import { color, Common } from '@stockbit/ui';
import Image from 'global/Image';
import { useRunningTradeStore } from 'global/Datafeed/store/runningTrade';

const { Text, Button } = Common;

const ButtonContainer = styled(Button)`
  display: flex;
  height: 28px;
  padding: 6px 10px;
  align-items: center;
  justify-content: space-between;
  gap: 2px;
  border-radius: 14px;
  border: 1px solid ${color.downgray};
  background: ${color.light};
  width: auto;
`;

const PlayIcon = () => (
  <Image src="/icon/rt-play.svg" alt="Play" />
);

const PauseIcon = () => (
  <Image src="/icon/rt-pause.svg" alt="Pause" />
);

const PausePlay = () => {
  const isPaused = useRunningTradeStore((s) => s.runningTrade.widget.isPaused);
  const [pause, play] = useRunningTradeStore((s) => ([
    s.pause,
    s.play,
  ]));

  const onClickButton = () => {
    if (isPaused) {
      play('widget');
    } else {
      pause('widget');
    }
  };

  return (
    <ButtonContainer onClick={onClickButton}>
      {isPaused ? <PlayIcon /> : <PauseIcon />}
      <Text
        weight="700"
        width="34px"
        size="12px"
        color={color.highgray}
      >
        {isPaused ? 'Play' : 'Pause'}
      </Text>
    </ButtonContainer>
  );
};

export default PausePlay;
